<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const currentUser = useMapGetter('getCurrentUser');

const icons = {
  chat:
    '<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/><path d="M8 12h.01"/><path d="M12 12h.01"/><path d="M16 12h.01"/>',
  cart:
    '<circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>',
  file:
    '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/>',
  settings:
    '<line x1="4" x2="4" y1="21" y2="14"/><line x1="4" x2="4" y1="10" y2="3"/><line x1="12" x2="12" y1="21" y2="12"/><line x1="12" x2="12" y1="8" y2="3"/><line x1="20" x2="20" y1="21" y2="16"/><line x1="20" x2="20" y1="12" y2="3"/><line x1="2" x2="6" y1="14" y2="14"/><line x1="10" x2="14" y1="8" y2="8"/><line x1="18" x2="22" y1="16" y2="16"/>',
};

const iconSvg = (name, color) =>
  `<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${icons[name]}</svg>`;

const chatUrl = computed(() => {
  const accountId = currentUser.value?.account_id;
  return accountId ? `/app/accounts/${accountId}/dashboard` : '/app/hub';
});

const apps = [
  {
    name: 'Chat',
    desc: 'Atendimento e mensagens',
    icon: 'chat',
    color: '#7c3aed',
    bg: '#f0ecfe',
    ready: true,
    to: chatUrl,
  },
  {
    name: 'Vendas',
    desc: 'Gestão de vendas',
    icon: 'cart',
    color: '#10b981',
    bg: '#e8f5e9',
    ready: false,
    to: '#',
  },
  {
    name: 'Wublo Sign',
    desc: 'Contratos e assinaturas digitais',
    icon: 'file',
    color: '#0ea5e9',
    bg: '#e0f2fe',
    ready: false,
    to: '#',
  },
  {
    name: 'Gestão',
    desc: 'Administração e relatórios',
    icon: 'settings',
    color: '#f59e0b',
    bg: '#fef3c7',
    ready: false,
    to: '#',
  },
];
</script>

<template>
  <div class="w-full h-full" style="padding: 40px 24px;">
    <div style="max-width: 960px; margin: 0 auto; text-align: center;">
      <h1 style="font-size: 28px; font-weight: 700; color: #0f172a; margin: 0 0 6px;">
        Escolha uma aplicação
      </h1>
      <p style="font-size: 15px; color: #64748b; margin: 0 0 30px;">
        Selecione o serviço que deseja acessar
      </p>

      <div
        style="display: grid; grid-template-columns: repeat(auto-fit, minmax(210px, 1fr)); gap: 20px;"
      >
        <a
          v-for="app in apps"
          :key="app.name"
          :href="app.to"
          :style="{
            background: '#ffffff',
            borderRadius: '16px',
            padding: '30px 22px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
            border: '1px solid #e2e8f0',
            textDecoration: 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            transition: 'transform 0.15s ease, box-shadow 0.15s ease',
          }"
          @mouseover="e => (e.currentTarget.style.transform = 'translateY(-4px)')"
          @mouseout="e => (e.currentTarget.style.transform = 'translateY(0)')"
        >
          <div
            :style="{
              width: '76px',
              height: '76px',
              borderRadius: '20px',
              background: app.bg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }"
          >
            <span v-html="iconSvg(app.icon, app.color)"></span>
          </div>
          <div style="font-size: 20px; font-weight: 700; color: #0f172a;">
            {{ app.name }}
          </div>
          <div style="font-size: 13px; color: #64748b;">{{ app.desc }}</div>
          <div
            v-if="!app.ready"
            style="font-size: 11px; font-weight: 600; color: #94a3b8; background: #f1f5f9; border-radius: 999px; padding: 3px 12px; margin-top: 4px;"
          >
            Em breve
          </div>
        </a>
      </div>
    </div>
  </div>
</template>